import { SonoraEntityType } from 'owa-editor-sonora-types';

export default function getActionCommandSearchQueryFilter(
    queryString: string,
    entity: SonoraEntityType | undefined
): string {
    if (entity !== null && entity !== undefined) {
        const queryFilter = SonoraEntityType[entity];
        return queryFilter + ' ' + queryString;
    }
    return queryString;
}
